module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_08_FeatureGraphic.547371ea.png";